import { useContext, useEffect, useState } from 'react';

import { S3Item } from 'types';

import { BucketContext } from 'contexts';

import defaultColor from 'assets/default_color.png';

import * as S from './ColorImage.styles';

type ColorImageProps = {
  source?: string;
  alt?: string;
};

const ColorImage = ({ source, alt = 'colour' }: ColorImageProps) => {
  const [error, setError] = useState(false);
  const [resolvedUrl, resolvedUrlSet] = useState<string>('');
  const { getUrl } = useContext(BucketContext);

  useEffect(() => {
    let cancelled = false;
    if (!source) {
      resolvedUrlSet('');
      return () => {
        cancelled = true;
      };
    }
    getUrl(`catalogue/${source}`)
      .then((res: S3Item) => {
        if (!cancelled && res?.url) resolvedUrlSet(res.url);
      })
      .catch(() => {
        if (!cancelled) resolvedUrlSet('');
      });
    return () => {
      cancelled = true;
    };
  }, [source, getUrl]);

  const showPlaceholder = !resolvedUrl || error;

  return (
    <S.Wrapper>
      <S.Image
        src={showPlaceholder ? defaultColor : resolvedUrl}
        alt={alt}
        onError={() => setError(true)}
      />
    </S.Wrapper>
  );
};

export { ColorImage };
